class Util {
    // 设置本地存储
    setStorage (name, data) {
      let dataType = typeof data
      if(dataType === 'object' ) {
        window.localStorage.setItem(name,JSON.stringify(data))
      } else if (['number','string','boolean'].indexOf(dataType) >= 0) {
        window.localStorage.setItem(name,data)
      } else {
        console.log('该类型不能用于本地存储！')
      }
    }
    // 获取本地存储
    getStorage (name) {
      let data = window.localStorage.getItem(name)
      if (data) {
        try {
          data = JSON.parse(data)
          return data
        } catch (err) {
          return data
        }
      } else {
        return ''
      }
    }
    // 删除本地存储
    rmStroage (name) {
      window.localStorage.removeItem(name)
    }
    // 获取浏览器参数
    getUrlParam (name) {
      let queryString = window.location.hash.split('?')[1] || ''
      let arr = queryString.split("&")
      let oneArr = []
      for(var i = 0; i < arr.length; i++) {
        oneArr = arr[i].split('=')
        if(oneArr[0] == name) {
          return decodeURIComponent(oneArr[1])
        }
      }
    }
    add_comma_toThousands (num) {
      var num = (num || 0).toString()
      var result = ''
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result
        num = num.slice(0, num.length - 3)
      }
      if (num) { result = num + result }
      return result
    }
  }
  
  export default Util
  


// WEBPACK FOOTER //
// ./src/util/util.js